import { useMediaQuery } from "usehooks-ts";
import { useMemo } from "react";

interface Device {
  isMobile: boolean;
  isWeb: boolean;
}

const useDevice = (): Device => {
  const isMobile = useMediaQuery("(max-width: 899px)");

  return useMemo(
    () => ({
      isMobile,
      isWeb: !isMobile,
    }),
    [isMobile],
  );
};

export default useDevice;
